export default __webpack_public_path__ + "static/media/arw-04250.663be06f.jpg";